import React from "react";
import { Hero } from "../components/home/Hero";
import { ServicesSection } from "../components/home/ServicesSection";
import { ApproachSection } from "../components/home/ApproachSection";
import { KinetipsSection } from "../components/home/KinetipsSection";
import { VisitSection } from "../components/home/VisitSection";
export function Home() {
  return <>
      <Hero data-id="element-404" data-mp="2x7iuf3g0b6mv" />
      <ServicesSection data-id="element-405" data-mp="1zi7co6o9f87p" />
      <ApproachSection data-id="element-406" data-mp="1ziz7vgdy33xg" />
      <KinetipsSection data-id="element-407" data-mp="1zjifa35yy9x8" />
      <VisitSection data-id="element-408" data-mp="1zkaahcvnm5mz" />
    </>;
}